import React, { useState, useEffect } from 'react';
import { getFormat } from './js/ajax.js';
import './App.css';
// import cityList from './data/city.json'

function App() {
    const [weather, setWeather] = useState(null);
    const [loading, setLoading] = useState(true);
    const [city, setCity] = useState(null);
    const [apiStatus, setApiStatus] = useState('');
    const cityList = [
        {
            id: 1,
            name: '北京',
            coord: { lat: 39.9042, lon: 116.4074 },
        },
        {
            id: 2,
            name: '上海',
            coord: { lat: 31.2304, lon: 121.4737 },
        },
        {
            id: 3,
            name: '广州',
            coord: { lat: 23.1291, lon: 113.2644 },
        },
        {
            id: 4,
            name: '深圳',
            coord: { lat: 22.5431, lon: 114.0579 },
        },
        {
            id: 5,
            name: '成都',
            coord: { lat: 30.5728, lon: 104.0668 },
        },
        {
            id: 6,
            name: '杭州',
            coord: { lat: 30.2741, lon: 120.1551 },
        },
        {
            id: 7,
            name: '武汉',
            coord: { lat: 30.5928, lon: 114.3055 },
        },
        {
            id: 8,
            name: '西安',
            coord: { lat: 34.3416, lon: 108.9398 },
        },
        {
            id: 9,
            name: '重庆',
            coord: { lat: 29.5630, lon: 106.5516 },
        },
        {
            id: 10,
            name: '天津',
            coord: { lat: 39.3434, lon: 117.3616 },
        },
        {
            id: 11,
            name: '南京',
            coord: { lat: 32.0603, lon: 118.7969 },
        },
        {
            id: 12,
            name: '苏州',
            coord: { lat: 31.2989, lon: 120.5853 },
        },
        {
            id: 13,
            name: '青岛',
            coord: { lat: 36.0671, lon: 120.3826 },
        },
        {
            id: 14,
            name: '厦门',
            coord: { lat: 24.4798, lon: 118.0894 },
        },
        {
            id: 15,
            name: '长沙',
            coord: { lat: 28.2282, lon: 112.9388 },
        },
    ]
    useEffect(() => {
        setCity(cityList[0]);
    }, []); // 只在组件挂载时设置一次

    useEffect(() => {
        if (city) {
            testApiCall();
        }
    }, [city]);// city 变化时调用

    const handleCityChange = (newCity) => {
        let cityobj = cityList.find(item => item.id == newCity);
        setLoading(true);
        setCity(cityobj);
    };

    // 测试API调用Get
    const testApiCall = () => {
        getFormat(
            '/api/weather',
            {
                lat: city.coord.lat,
                lon: city.coord.lon,
                appid: '456d5f2262beb65bc08fc46c064a37cd',
                lang: 'zh_cn',
                units: 'metric'
            },
            (response) => {
                setLoading(false);
                setWeather(response)
                console.log('API测试成功:', response);
                setApiStatus('API测试成功！');
            },
            (error) => {
                setLoading(false);
                console.error('API测试失败:', error);
                setApiStatus('API测试失败！');
            }
        );
    };

    if (loading) {
        return (
            <div className="app">
                <div className="loading">
                    <div className="spinner"></div>
                    <p>正在获取天气信息...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="app">
            <div className="weather-container">
                <h1 className="title">天气应用</h1>

                <div className="city-selector">
                    <label htmlFor="city-select">选择城市：</label>
                    <select
                        id="city-select"
                        value={city.id}
                        onChange={(e) => handleCityChange(e.target.value)}
                    >
                        {cityList.map((cityItem) => (
                            <option key={cityItem.id} value={cityItem.id}>
                                {cityItem.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="weather-card">
                    <div className='weather-box'>
                        <div className='weather-icon'>
                            <img
                                src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
                                alt={weather.weather[0].description} />
                        </div>
                        <div className='weather-info'>
                            <h2 className="city-name">{city.name}</h2>
                            <div className="temperature">
                                <span className="temp-value">{weather.main.temp}°C</span>
                            </div>
                            <div className="condition">{weather.weather[0].description}</div>
                        </div>
                    </div>
                    <div className="details">
                        <div className="detail-item">
                            <span className="label">湿度：</span>
                            <span className="value">{weather.main.humidity}%</span>
                        </div>
                        <div className="detail-item">
                            <span className="label">风力：</span>
                            <span className="value">{weather.wind.gust}m/s</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default App; 